import { memo } from "react";
import type { LabeledCircleProps } from "./types";

export const LabeledCircle = memo(function LabeledCircle({
  x,
  y,
  radius,
  fillColor,
  strokeColor,
  label,
  opacity = 1,
}: LabeledCircleProps) {
  const circleRadius = radius * 1.4;
  const fontSize = Math.max(radius * 1.4, Math.min(circleRadius * 0.6, 36));

  return (
    <g opacity={opacity}>
      <circle cx={x} cy={y} r={circleRadius} fill={fillColor} />
      <circle
        cx={x}
        cy={y}
        r={circleRadius}
        fill="none"
        stroke={strokeColor}
        strokeWidth={2}
        vectorEffect="non-scaling-stroke"
      />
      {label && (
        <text
          x={x}
          y={y}
          fill="#000000"
          fontSize={fontSize}
          fontWeight="bold"
          fontFamily="Arial"
          textAnchor="middle"
          dominantBaseline="central"
        >
          {label}
        </text>
      )}
    </g>
  );
});
